//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  components: {},

  props: {
    placeholder: { type: String },

    value: {
      type: [
        String,
        Object,
      ],
    },

    name: {
      type: String,
      default: '',
    },
  },

  data () {
    return {}
  },

  computed: {
    show: {
      set (value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      },
    },
  },

  // methods: {
  // handlerBlurEvent () {
  //   if (getIsIos()) {
  //     window.scrollTo(0, 0)
  //   }
  // },
  // },
}
